import React from 'react';
import Fade from 'react-reveal/Fade';
import { Carousel } from 'react-bootstrap';
import './HeroPart.css'
const HeroPart = () => {
    return (
        <div>
            <Carousel>
                <Carousel.Item style={{ height: "600px" }} interval={1000}>
                    <img
                        className="d-block w-100"
                        src="http://travesia.axiomthemes.com/wp-content/uploads/2017/10/slider1_1.jpg"
                        alt="First slide"
                    />
                    <Carousel.Caption className="padding">
                        <Fade right>
                            <h3 className="display-4 text text-bold text-light">Discover Night Paris</h3>
                        </Fade>
                        <Fade left>
                        <button className="btn btn-danger rounded-pill mt-3">BOOK YOUR TRAVEL</button>
                        </Fade>
                    </Carousel.Caption>
                </Carousel.Item >
                <Carousel.Item style={{ height: "600px" }} interval={500}>
                    <img
                        className="d-block w-100"
                        src="http://travesia.axiomthemes.com/wp-content/uploads/2017/10/slider1_2.jpg"
                        alt="Second slide"
                    />
                    <Carousel.Caption className="padding">
                        <Fade right>
                            <h1 className="display-4 text text-bold text-light">Amazing Buenos Aires</h1>
                        </Fade>
                        <Fade left>
                        <button className="btn btn-danger rounded-pill mt-3">BOOK YOUR TRAVEL</button>
                        </Fade>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item style={{ height: "600px" }}>
                    <img
                        className="d-block w-100"
                        src="http://travesia.axiomthemes.com/wp-content/uploads/2017/10/slider1_3.jpg"
                        alt="Third slide"
                    />
                    <Carousel.Caption className="padding">
                        <Fade right>
                            <h3 className="display-4 text text-bold text-light">Romantic Vanice Travel</h3>
                        </Fade>
                        <Fade left>
                            <button className="btn btn-danger rounded-pill mt-3">BOOK YOUR TRAVEL</button>
                        </Fade>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </div>
    );
};
export default HeroPart;